import React from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import axios from 'axios';

import Context from './../../store/CreateContext';
import Header from './../../components/Header';
import { Services } from '../../../../Services';
import { Col, Row } from 'reactstrap';


function ShareToComponent() {
  const [usersList, setUsersList] = React.useState([]);
  const context = React.useContext(Context);

  const GET_USERLIST = React.useCallback(async () => {
    try {
      const body = {
        user: localStorage.getItem('dataUser')
      };
      const respUsers = await axios.post(`${Services.REPORTS.path}shared/users/list`, body);
      setUsersList(respUsers.data.users);
    } catch (error) {
      console.error('ShareToComponent', error);
    }
  }, []);

  const handleOnChange = (evt, data) => {
    // console.log('this is the shared -- ', data.value);
    context.set_share_to(data.value);
  };


  React.useEffect(() => {
    GET_USERLIST();
  }, [GET_USERLIST]);

  return (
    <>
      <Header
        as='h6'
        icon='fas fa-share-square fa-lg mr-2'
        title='Share'
      />
      <Form size='mini'>
        <Row>
          <Col xs='6'>
            <Form.Group widths='equal'>
              <Form.Field>
                <label>User Name</label>
                <Dropdown
                  name='share-users'
                  placeholder='User Name'
                  clearable
                  fluid
                  multiple
                  selection
                  search
                  defaultValue={context.share_to}
                  value={context.share_to}
                  options={usersList}
                  onChange={handleOnChange}
                />
              </Form.Field>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ShareToComponent;